var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClosePopup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.76 11.734c.115.115.25.19.407.227.156.041.31.041.461 0a.862.862 0 0 0 .407-.22l4.466-4.473 4.474 4.474a.85.85 0 0 0 .625.25c.25.005.464-.08.642-.258a.888.888 0 0 0 .258-.642.849.849 0 0 0-.25-.625L7.775 5.993l4.473-4.466a.849.849 0 0 0 .25-.625.832.832 0 0 0-.257-.642.888.888 0 0 0-.642-.258.85.85 0 0 0-.625.25L6.5 4.726 2.035.252a.862.862 0 0 0-.407-.219.922.922 0 0 0-.461-.007A.807.807 0 0 0 .76.26a.924.924 0 0 0-.227.876.871.871 0 0 0 .227.391l4.466 4.466L.76 10.467a.87.87 0 0 0-.227.399.922.922 0 0 0-.007.461.84.84 0 0 0 .234.407Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosePopup);
export default __webpack_public_path__ + "static/media/close_popup.9949626e2970bd202fc68a2d665e2f55.svg";
export { ForwardRef as ReactComponent };